<template>
    <div class="container" style="width: 100%;">
        <div style="float:left;width: 13%;background-image: url('../../../static/images/left_bg.png');background-size: 100% auto;height: 55pt;background-repeat: no-repeat;background-position: center">

        </div>

        <div style="float:left;width: 74%;background-image: url('../../../static/images/center_bg.png');background-size: 100% auto;height: 55pt;background-repeat: no-repeat;background-position: center;">
            <div class="bi_title">
                <!--                德启全国产品实时动态-->
                德启全国产品实时动态
            </div>
        </div>

        <div style="float:left;width: 13%;background-image: url('../../../static/images/right_bg.png');background-size: 100% auto;height: 55pt;background-repeat: no-repeat;background-position: center">

        </div>

        <!--        <div class="volume_statistics">-->
        <!--            大数据统计-->
        <!--        </div>-->
        <!-- 暂时去掉 -->
        <!--        <div style="display: flex;justify-content: center;width: 100%;margin-top: 13px;align-items: center">-->
        <!--            <div class="current_date">-->
        <!--                {{currentDate}}-->
        <!--            </div>-->
        <!--            <div class="current_year">-->
        <!--                {{currentYear}}-->
        <!--            </div>-->
        <!--            <div class="current_week">-->
        <!--                {{currentWeek}}-->
        <!--            </div>-->
        <!--        </div>-->

        <div style="width: 100%;margin-top: 20px;display: flex;justify-content: center;">
            <div class="arrange_area">
                <div class="arrange_area_number">
                    <countTo :startVal='past_arrange_area_number' :endVal='arrangeAreaNumber'
                             :duration='3000' :decimals="arrangeAreaNumberDecimals"></countTo>
                    <span class="number_style" v-show="arrangeAreaNumberMillionFlag">百万</span>
                    <span class="number_style" v-show="arrangeAreaNumberHundredMillionFlag">亿</span>
                </div>
                <div class="arrange_area_text">
                    累计部署量
                </div>
            </div>

            <div class="device_roam" style="margin-left: 8pt;">
                <div class="device_roam_number">
                    <countTo :startVal='past_reverse_numbers' :endVal='reverseNumbers' :duration='3000'
                             :decimals="reverseNumbersDecimals"></countTo>
                    <span class="number_style" v-show="reverseNumbersMillionFlag">百万</span>
                    <span class="number_style" v-show="reverseNumbersHundredMillionFlag">亿</span>
                </div>
                <div class="device_roam_text">
                    累计使用量
                </div>
            </div>

            <div class="today_exception" style="margin-left: 8pt;">
                <div class="today_exception_number">
                    <countTo :startVal='past_today_reverse_exception_number' :endVal='todayReverseExceptionNumber'
                             :duration='3000' :decimals="todayReverseExceptionNumberDecimals"></countTo>
                    <span class="number_style" v-show="todayReverseExceptionNumberMillionFlag">百万</span>
                    <span class="number_style" v-show="todayReverseExceptionNumberHundredMillionFlag">亿</span>
                </div>
                <div class="today_exception_text">
                    剩余事件数
                </div>
            </div>

            <div class="deal_event" style="margin-left: 8pt;">
                <div class="deal_event_number">
                    <countTo :startVal='past_deal_event_number' :endVal='dealEventNumber'
                             :duration='3000' :decimals="dealEventNumberDecimals"></countTo>
                    <span class="number_style" v-show="dealEventNumberMillionFlag">百万</span>
                    <span class="number_style" v-show="dealEventNumberHundredMillionFlag">亿</span>
                </div>
                <div class="deal_event_text">
                    已处理事件数
                </div>
            </div>
        </div>

        <img src="../../../static/images/reset.png" class="reSet" @click="reSet" id="reSet"/>
        <img src="../../../static/images/reset_click.png" class="reSet" id="reSetClick" style="display: none"/>

        <div id="map" class="echarts_map" style="width: 100%;height: 90vw;position: relative;margin-top: 20px">

        </div>

        <div class="bi_product" style="float:none;">
            <div class="bi_product_add">
                产品部署趋势
            </div>
        </div>

        <div id="product_arrange" :style="{width: '100%', height: '70vw'}"></div>

        <div class="bi_device">
            <div class="bi_insert_device">
                产品部署分布
            </div>
        </div>

        <div id="insert_device" :style="{width: '100%', height: '70vw'}"></div>

        <div class="bi_data">
            <div class="bi_data_type">
                产品使用趋势
            </div>
        </div>

        <div id="total_turnover" :style="{width: '100%', height: '70vw'}"></div>

        <div class="bi_court">
            <div class="bi_insert_court">
                接入单位分布
            </div>
        </div>

        <div id="insert_court" :style="{width: '100%', height: '70vw'}"></div>

        <div class="bi_product_type">
            <div class="bi_product_type_distribute">
                产品类型分布
            </div>
        </div>
        <div id="product_type" :style="{width: '100%', height: '70vw'}"></div>
    </div>
</template>

<script>
    import countTo from 'vue-count-to';
    import echarts from 'echarts';
    import china from 'echarts/map/json/china.json'
    import {selectAllYears, selectReverseYears,} from '@/api/center/hostinfo'
    import $ from 'jquery'

    import {
        selectAllException,
        selectArrangeAreaNumber,
        selectDealEventNumber,
        selectdeployedDevicesTotalNumber,
        selectInsertCourt,
        selectInsertDevice,
        selectProductArrange,
        selectProductTypeSpread,
        selectReverseNumbers,
        selectTodayReverseExceptionNumber,
        selectTotalTurnover
    } from '@/api/center/statistical'
    import courtMap from "../../../static/js/courtMap";

    echarts.registerMap('china', china)

    let target = new Map();
    let total = 0
    export default {
        components: {countTo},
        data() {
            return {
                arrangeAreaNumberDecimals: 0,
                reverseNumbersDecimals: 0,
                todayReverseExceptionNumberDecimals: 0,
                dealEventNumberDecimals: 0,

                arrangeAreaNumberMillionFlag: false,
                arrangeAreaNumberHundredMillionFlag: false,
                reverseNumbersMillionFlag: false,
                reverseNumbersHundredMillionFlag: false,
                todayReverseExceptionNumberMillionFlag: false,
                todayReverseExceptionNumberHundredMillionFlag: false,
                dealEventNumberMillionFlag: false,
                dealEventNumberHundredMillionFlag: false,

                currentWeek: '',
                currentYear: '',
                currentDate: '',
                past_arrange_area_number: 0,
                past_reverse_numbers: 0,
                past_today_reverse_exception_number: 0,
                past_deal_event_number: 0,
                yearsList: [],
                exceptionList: [],
                productTypeSpreadList: [],
                productTypeNameList: [],
                productTypeData: {
                    value: '',
                    name: '',
                    itemStyle: {
                        color: ''
                    }
                },
                insertDeviceAreaList: [],
                insertDeviceNumList: [],
                arrangeAreaNumber: 0, // 总部署地区
                reverseNumbers: 0, // 总设备流转量
                todayReverseExceptionNumber: 0, // 今日异常数量
                dealEventNumber: 0, // 总处理事件
                insertDevice: {
                    title: {
                        text: '数量:  台',
                        x: '24px',//水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
                        y: '20px',
                        textStyle: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 14,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            color: '#FFFFFF',
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    // dataZoom: [{
                    //     type: 'inside',
                    //     show: true,
                    //     xAxisIndex: [0],
                    //     left: '9%',
                    //     bottom: -5,
                    //     start: 0,
                    //     end: 80 //初始化滚动条
                    // }],
                    grid: {
                        top: '25%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        // data: ['北京', '上海', '天津', '深圳', '南京', '成都', '苏州'],
                        data: self.insertDeviceAreaList,
                        axisLabel: {
                            color: '#FFFFFF',
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                color: '#FFFFFF',
                                fontSize: '9',
                                itemSize: ''
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#FFFFFF',
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#66C6E7', // 颜色
                                width: 1, // 粗细
                                opacity: 0.2,
                            }
                        },
                    },
                    // series: [{
                    //     // data: [120, 200, 150, 80, 70, 110, 130],
                    //     data: self.insertDeviceNumList,
                    //     type: 'bar',
                    //     showBackground: false,
                    //     backgroundStyle: {
                    //         color: 'rgba(220, 220, 220, 0.8)'
                    //     },
                    //     barWidth: '20%',
                    //     itemStyle: {normal: {color: '#5682FD'}}
                    // }]
                    series: [
                        {
                            // data: [120, 200, 150, 80, 70, 110, 130],
                            data: self.insertDeviceNumList,
                            type: 'bar',
                            showBackground: false,
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            barWidth: '20%',
                            itemStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#5682fd'
                                }, {
                                    offset: 1,
                                    color: '#00013b'
                                }]),
                                // shadowColor: 'rgba(35,55,139, 0.5)',
                                shadowColor: '#23378b',
                                shadowBlur: 0,
                                shadowOffsetX: -4,
                                shadowOffsetY: -2,

                                // borderWidth: 1,
                                // borderColor: '#338484'
                            }
                        }
                    ]
                },
                productArrange: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: "#002d69",
                        textStyle: {
                            color: "#2AA7D3",
                            fontWeight: 400,
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 50, 0, 35],
                        // data: self.yearsList
                        data: [{
                            name: '',
                            textStyle: {
                                color: '#2C80FF'
                            }
                        }, {
                            name: '',
                            textStyle: {
                                color: '#05CDF4'
                            }
                        }
                        ]

                    },
                    grid: {
                        top: '25%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
                        axisLabel: {
                            color: '#5093C1',
                            textStyle: {
                                color: '#FFFFFF',
                                fontSize: '9',
                                itemSize: ''
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#5093C1'
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#66C6E7', // 颜色
                                width: 1, // 粗细
                                opacity: 0.2,
                            }
                        }

                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: ""},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#2C80FF",//折线点的颜色
                                    lineStyle: {
                                        color: "#2C80FF"//折线的颜色
                                    }
                                }
                            }
                        },
                        {
                            name: '',
                            type: 'line',
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: ""},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#05CDF4",//折线点的颜色
                                    lineStyle: {
                                        color: "#05CDF4"//折线的颜色
                                    }
                                }
                            }
                        },
                    ]
                },
                productTypeSpread: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [45, 25, 0, 0],
                        align: 'left',
                        icon: 'circle',
                        // data: ["产品1", "产品2", "产品3", "产品4", "产品5"],
                        data: [],
                        textStyle: {
                            color: '#FFFFFF'
                        },
                        // 使用回调函数
                        formatter: function (name) {
                            let lists = [];
                            let inum = target.get(name) / total * 100;
                            //保留inum小数点后２位
                            let vnum = parseFloat(inum).toFixed(2);
                            lists.push(name + '    ' + vnum + '%');
                            return lists;
                        },
                    },
                    grid: {
                        left: 0
                    },
                    graphic: {       //图形中间文字
                        type: "text",
                        left: "20%",
                        top: "center",
                        style: {
                            text: "产品类型",
                            textAlign: "center",
                            fill: "#fff",
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#AADDFF',
                            fontFamily: 'Adobe Heiti Std'
                        }
                    },
                    series: [
                        {
                            name: '产品类型',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            center: ['30%', '50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: false,
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            // data: [
                            //     {value: 335, name: '产品1', itemStyle: {color: '#02B4D2'}},
                            //     {value: 310, name: '产品2', itemStyle: {color: '#FFB608'}},
                            //     {value: 234, name: '产品3', itemStyle: {color: '#9802FE'}},
                            //     {value: 135, name: '产品4', itemStyle: {color: '#00BE8E'}},
                            //     {value: 1548, name: '产品5', itemStyle: {color: '#103EE6'}}
                            // ]
                            data: []
                            // data: self.productTypeSpreadList
                        }
                    ]
                },
                insertCourt: {
                    title: {
                        text: '',
                        subtext: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    // dataZoom: [
                    //     {
                    //         type: 'inside',
                    //         yAxisIndex: [0],
                    //         start: 20,
                    //         end: 100
                    //     }
                    // ],
                    legend: {
                        itemHeight: 10,
                        itemWidth: 16,
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 70, 0, 0],
                        data: [{
                            name: '已接入',
                            textStyle: {
                                color: '#00F6FF'
                            }
                        }, {
                            name: '未接入',
                            textStyle: {
                                color: '#004EFF'
                            }
                        }],
                        icon: 'rect',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        axisLabel: {
                            color: '#5ABAF2'
                        },
                        splitLine: {
                            show: false
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: [],
                        axisLabel: {
                            color: '#5ABAF2',
                            textStyle: {
                                fontSize: 9     //更改坐标轴文字大小
                            }
                        },
                        splitLine: {
                            show: false
                        },
                    },
                    series: [
                        {
                            name: '已接入',
                            type: 'bar',
                            data: [],
                            barWidth: '15%',
                            itemStyle: {
                                normal: {
                                    color: "#00F6FF",//折线点的颜色
                                    lineStyle: {
                                        color: "#00F6FF"//折线的颜色
                                    }
                                }
                            }
                        },
                        {
                            name: '未接入',
                            type: 'bar',
                            data: [],
                            barWidth: '15%',
                            itemStyle: {
                                normal: {
                                    color: "#004EFF",//折线点的颜色
                                    lineStyle: {
                                        color: "#004EFF"//折线的颜色
                                    }
                                }
                            }
                        }
                    ]
                },
                totalTurnover: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // orient: 'vertical',
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 70, 0, 0],
                        // data: ['类型1', '类型2'],
                        data: [{
                            name: '',
                            textStyle: {
                                color: '#F9AF1A'
                            }
                        }, {
                            name: '',
                            textStyle: {
                                color: '#40DEFF'
                            }
                        }],
                        icon: 'circle',
                    },
                    grid: {
                        top: '15%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
                        axisLabel: {
                            color: '#FFFFFF',
                            textStyle: {
                                color: '#FFFFFF',
                                fontSize: '8',
                                itemSize: ''
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#FFFFFF',
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            symbol: 'none',
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#F9AF1A",//折线点的颜色
                                    lineStyle: {
                                        color: "#F9AF1A"//折线的颜色
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: "rgba(0, 201, 255, 0.3)"},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                        },
                        {
                            name: '',
                            type: 'line',
                            symbol: 'none',
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#40DEFF",//折线点的颜色
                                    lineStyle: {
                                        color: "#40DEFF"//折线的颜色
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: "rgba(0, 201, 255, 0.3)"},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                        },
                    ]
                },
                reverseYearsList: [],
                provinceList: [],
                insertCourtList: [],
                deployedDeviceList: [],
                echartsMap: {
                    title: {
                        text: '',
                        subtext: '',
                        left: ''
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            // let length = JSON.stringify(params.value).split(',')[2].length
                            // let value = JSON.stringify(params.value).split(',')[2].substring(0, length - 1)
                            if (params.name != "" && params.value) {
                                let result = params.name + '<br/>部署产品总量：' + params.value
                                return result
                            }
                        },
                        // backgroundColor: "#002d69",
                        // textStyle: {
                        //     color: "#2AA7D3",
                        //     fontWeight: 400,
                        // }
                    },
                    legend: {
                        data: []
                    },
                    visualMap: {
                        show: false,
                        min: 0,
                        max: 171,
                        text: ['高', '低'],
                        calculable: true,
                        inRange: {
                            // color: ['#044f69', '#06cac7']
                            color: ['#79cefd']
                        },
                        textStyle: {
                            color: '#FFFFFF'
                        },
                        seriesIndex: 1
                    },
                    geo: [{
                        show: true,
                        roam: true,
                        scaleLimit: {
                            min: 0.7,
                            // max: 1
                        },
                        map: 'china',
                        layoutCenter: ['50%', '40%'],
                        layoutSize: 270,
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#E2F71E',
                                    fontSize: 13
                                }
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(20,151,237, 0.7)',
                                borderColor: 'rgba(0,255,255, 0.5)'
                            },
                            emphasis: {
                                areaColor: '#1bb6df'
                            },
                        },
                        zoom: 1.2
                    }],
                    series: [
                        {
                            name: '部署产品总量', // series名称
                            type: 'effectScatter', // series图表类型
                            coordinateSystem: 'geo', // series坐标系类型
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            symbolSize: 7,
                            tooltip: {
                                show: false
                            },
                            data: []
                        },
                        {
                            type: 'map',  // 类型为地图
                            map: 'china',
                            geoIndex: 0,
                            data: [
                                // {name: '江苏', value: 9999}
                            ]
                        }
                    ]
                }
            }
        },
        mounted() {
            let self = this
            self.getInsertDevice()
            self.initMap()
            self.getInsertCourt()

            target = new Map();
            total = 0;
            self.getProductTypeSpread()
            self.getArrangeAreaNumber()
            self.getTotalTurnover()
            self.getProductArrange()
            self.getReverseNumbers()
            self.getTodayReverseExceptionNumber()
            self.getDealEventNumber()
            self.getAllException()

            setInterval(function () {
                self.getInsertDevice()
                self.initMap()
                self.getInsertCourt()

                target = new Map();
                total = 0;
                self.getProductTypeSpread()
                self.getArrangeAreaNumber()
                self.getTotalTurnover()
                self.getProductArrange()
                self.getReverseNumbers()
                self.getTodayReverseExceptionNumber()
                self.getDealEventNumber()
                self.getAllException()
            }, 1000 * 60 * 15)


            // 暂时去掉
            // setInterval(function () {
            //     let date = new Date()
            //     self.currentDate = self.formatCurrentDate(date)
            //     self.currentYear = self.formatCurrentYear(date)
            //     self.currentWeek = self.formatCurrentWeek(date)
            // }, 1000)

        },
        methods: {
            formatCurrentDate(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
                var day = date.getDay();
                var week = weeks[day];
                return h + ":" + m1 + ":" + s;
            },

            formatCurrentYear(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                return y + "-" + m + "-" + d;
            },

            formatCurrentWeek(date) {
                var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
                var day = date.getDay();
                var week = weeks[day];
                return week;
            },

            /**
             *  日期转换
             */
            formatDate(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                return y + "-" + m + "-" + d + " " + h + ":" + m1 + ":" + s;
            },

            // 重置地图大小和位置
            reSet() {
                let self = this
                $("#reSet").css("display", "none")
                $("#reSetClick").css("display", "block")
                let myChart = echarts.init(document.getElementById('map'))
                myChart.getOption().geo[0].zoom = 1.2
                myChart.getOption().geo[0].layoutCenter = ['50%', '40%']
                myChart.setOption(self.echartsMap, true)
                setTimeout(function () {
                    $("#reSet").css("display", "block")
                    $("#reSetClick").css("display", "none")
                }, 200)
            },

            // 总流转量
            getTotalTurnover() {
                let self = this
                self.reverseYearsList = []
                let myChart = echarts.init(document.getElementById('total_turnover'))

                selectReverseYears().then(data => {

                    data.result.forEach(item => {
                        self.reverseYearsList.push(item + "年")
                    })
                    console.log(self.reverseYearsList)

                    // 只获取近两年
                    self.totalTurnover.legend.data[0].name = self.reverseYearsList[0]
                    self.totalTurnover.legend.data[1].name = self.reverseYearsList[1]

                    self.totalTurnover.series[0].name = self.reverseYearsList[0]
                    self.totalTurnover.series[1].name = self.reverseYearsList[1]

                })

                selectTotalTurnover().then(data => {
                    let list = Object.keys(data.result)

                    for (let i = 0; i < list.length; i++) {
                        self.totalTurnover.series[i].data = Object.values(data.result)[i]
                    }

                    // 绘制图表
                    myChart.setOption(self.totalTurnover, true);
                })

            },

            // 接入法院
            getInsertCourt() {
                let self = this
                self.provinceList = []
                self.insertCourtList = []
                selectInsertCourt().then(data => {
                    let list = []
                    // 只显示14个接入省市
                    if (data.result.length > 14) {
                        for (let i = data.result.length - 14; i < data.result.length; i++) {
                            list.push(data.result[i])
                        }
                    } else {
                        data.result.forEach(item => {
                            list.push(item)
                        })
                    }
                    list.forEach(item => {
                        self.provinceList.push(item.areaName)
                        self.insertCourtList.push(item.total)
                    })
                    let myChart = echarts.init(document.getElementById('insert_court'))
                    self.insertCourt.yAxis.data = self.provinceList
                    console.log("provinceList", self.provinceList)
                    console.log("insertCourtList", self.insertCourtList)
                    self.insertCourt.series[0].data = self.insertCourtList
                    let map = new Map()
                    for (let i = 0; i < self.provinceList.length; i++) {
                        map.set(self.provinceList[i], courtMap.courtMap[self.provinceList[i]])
                    }

                    console.log("map", map)
                    for (let i = 0; i < self.provinceList.length; i++) {
                        map.forEach(function (value, key) {
                            if (self.provinceList[i] == key) {
                                self.insertCourt.series[1].data.push(value - self.insertCourtList[i])
                            }
                        })
                    }

                    // 绘制图表
                    myChart.setOption(self.insertCourt, true);
                    console.log("self.insertCourt", self.insertCourt)
                })

            },

            // 初始化地图
            initMap() {
                let self = this
                self.deployedDeviceList = []
                self.echartsMap.series[0].data = []
                self.echartsMap.series[1].data = []
                let myChart = echarts.init(document.getElementById('map'))
                // 部署产品总量
                selectdeployedDevicesTotalNumber().then(data => {
                    self.deployedDeviceList = data.result

                    self.deployedDeviceList.forEach(item => {
                        let deployedDevice = {
                            name: '',
                            value: [],
                            label: {show: true, fontSize: 13, color: '#E2F71E', position: 'right', formatter: '{b}'},
                            itemStyle: {color: '#E2F71E'}
                        }
                        deployedDevice.name = ''
                        deployedDevice.value.push(item.longitude)
                        deployedDevice.value.push(item.latitude)
                        deployedDevice.value.push(0)
                        self.echartsMap.series[0].data.push(deployedDevice)

                        let mapData = {
                            name: '', value: 0
                        }
                        mapData.name = item.areaName
                        mapData.value = item.total
                        self.echartsMap.series[1].data.push(mapData)
                    })

                    console.log("self.deployedDeviceList", self.deployedDeviceList)
                    self.echartsMap.series[0].data.forEach(item => {
                        self.deployedDeviceList.forEach(deployedDevice => {
                            if (deployedDevice.areaName == item.name) {
                                console.log(item.name)
                                item.value[2] = deployedDevice.total
                            }
                        })
                    })

                    myChart.on('georoam', function (params) {
                        console.log("layoutCenter", myChart.getZr())
                    })

                    myChart.setOption(self.echartsMap, true)
                    console.log(self.echartsMap)
                })


                // debugger
                // myChart.setOption(self.echartsMap, true)

            },

            // 设备部署增量
            getProductArrange() {

                let self = this
                self.yearsList = []
                selectAllYears().then(data => {
                    data.result.forEach(item => {
                        self.yearsList.push(item + "年")
                    })
                    // 只获取近两年
                    self.productArrange.legend.data[0].name = self.yearsList[0]
                    self.productArrange.legend.data[1].name = self.yearsList[1]

                    self.productArrange.series[0].name = self.yearsList[0]
                    self.productArrange.series[1].name = self.yearsList[1]
                    // console.log(self.yearsList)
                })

                let myChart = echarts.init(document.getElementById('product_arrange'))

                selectProductArrange().then(data => {
                    let list = Object.keys(data.result)

                    for (let i = 0; i < list.length; i++) {
                        self.productArrange.series[i].data = Object.values(data.result)[i]
                    }

                    // 绘制图表
                    myChart.setOption(self.productArrange, true)
                })


            },

            // 接入设备
            getInsertDevice() {
                let self = this
                self.insertDeviceAreaList = []
                self.insertDeviceNumList = []
                selectInsertDevice().then(data => {
                    let list = []
                    // 只显示13个接入省市
                    if (data.result.length > 13) {
                        for (let i = 0; i < 13; i++) {
                            list.push(data.result[i])
                        }
                    } else {
                        data.result.forEach(item => {
                            list.push(item)
                        })
                    }
                    list.forEach(item => {
                        self.insertDeviceAreaList.push(item.areaName)
                        self.insertDeviceNumList.push(item.total)
                    })
                    let myChart = echarts.init(document.getElementById('insert_device'))
                    self.insertDevice.series[0].data = self.insertDeviceNumList
                    self.insertDevice.xAxis.data = self.insertDeviceAreaList
                    // 绘制图表
                    myChart.setOption(self.insertDevice, true);
                })
            },

            // 产品类型分布
            getProductTypeSpread() {
                let self = this
                self.productTypeNameList = []
                self.productTypeSpreadList = []
                selectProductTypeSpread().then(data => {
                    let productTypeList = data.result
                    let productTypeDataList = productTypeList
                    let totalNum = 0
                    let productNum = 0
                    if (productTypeList.length > 7) {
                        productTypeDataList = []
                        productTypeList.forEach(item => {
                            totalNum += item.total
                        })
                        for (let i = 0; i < 7; i++) {
                            productNum += productTypeList[i].total
                            productTypeDataList.push(productTypeList[i])
                        }
                        console.log(totalNum + '-----' + productNum)

                    }
                    productTypeDataList.forEach(item => {
                        self.productTypeData = {
                            value: '',
                            name: '',
                            itemStyle: {
                                color: ''
                            }
                        }
                        self.productTypeNameList.push(item.productName)
                        self.productTypeData.value = item.total
                        self.productTypeData.name = item.productName
                        // 产品添加颜色
                        if (self.productTypeData.name == '云柜') {
                            self.productTypeData.itemStyle.color = '#01B4D2'
                        } else if (self.productTypeData.name == '中间柜') {
                            self.productTypeData.itemStyle.color = '#FFB508'
                        } else if (self.productTypeData.name == '易诉柜') {
                            self.productTypeData.itemStyle.color = '#9702FE'
                        } else if (self.productTypeData.name == '记名柜') {
                            self.productTypeData.itemStyle.color = '#00BD8D'
                        } else if (self.productTypeData.name == '送达柜') {
                            self.productTypeData.itemStyle.color = '#00F6FF'
                        } else if (self.productTypeData.name == '虚拟柜') {
                            self.productTypeData.itemStyle.color = '#EF2051'
                        } else if (self.productTypeData.name == '交转柜') {
                            self.productTypeData.itemStyle.color = '#FCE38A'
                        } else if (self.productTypeData.name == '其他') {
                            self.productTypeData.itemStyle.color = '#258FFF'
                        }
                        self.productTypeSpreadList.push(self.productTypeData)
                    })

                    if (productTypeList.length > 7) {
                        self.productTypeData = {
                            value: '',
                            name: '',
                            itemStyle: {
                                color: ''
                            }
                        }
                        self.productTypeNameList.push('其他')

                        self.productTypeData.value = totalNum - productNum
                        self.productTypeData.name = '其他'
                        self.productTypeSpreadList.push(self.productTypeData)
                    }
                    console.log("self.productTypeNameList", self.productTypeNameList)
                    console.log("self.productTypeSpreadList", self.productTypeSpreadList)

                    // 产品类型分布的百分比
                    let mdataList = self.productTypeSpreadList
                    mdataList.forEach((item) => {
                        // 计算value的和，用来算百分比
                        total += item.value
                        // 组成 map {A:1212} ,用来下面获取 value
                        target.set(item.name, item.value)
                    })

                    let myChart = echarts.init(document.getElementById('product_type'))
                    self.productTypeSpread.legend.data = self.productTypeNameList
                    self.productTypeSpread.series[0].data = self.productTypeSpreadList
                    // 绘制图表
                    myChart.setOption(self.productTypeSpread, true);
                })
            },

            // 累计部署量
            getArrangeAreaNumber() {
                let self = this
                selectArrangeAreaNumber().then(data => {
                    self.past_arrange_area_number = self.arrangeAreaNumber
                    self.arrangeAreaNumber = data.result
                    if (self.arrangeAreaNumber / (10000 * 100) > 1) {
                        self.arrangeAreaNumber = Number((self.arrangeAreaNumber / (10000 * 100)).toFixed(2))
                        self.arrangeAreaNumberMillionFlag = true
                        self.arrangeAreaNumberHundredMillionFlag = false
                        // 保留两位小数
                        self.arrangeAreaNumberDecimals = 2
                    } else if (self.arrangeAreaNumber / (10000 * 100 * 100) > 1) {
                        self.arrangeAreaNumber = Number((self.arrangeAreaNumber / (10000 * 100 * 100)).toFixed(2))
                        self.arrangeAreaNumberMillionFlag = false
                        self.arrangeAreaNumberHundredMillionFlag = true
                        // 保留两位小数
                        self.arrangeAreaNumberDecimals = 2
                    } else if (self.arrangeAreaNumber / 10000 < 1) {
                        self.arrangeAreaNumberMillionFlag = false
                        self.arrangeAreaNumberHundredMillionFlag = false
                        // 不保留小数
                        self.arrangeAreaNumberDecimals = 0
                    }
                })
            },

            // 累计使用量
            getReverseNumbers() {
                let self = this
                selectReverseNumbers().then(data => {
                    self.past_reverse_numbers = self.reverseNumbers
                    self.reverseNumbers = data.result
                    if (self.reverseNumbers / (10000 * 100) > 1) {
                        self.reverseNumbers = Number((self.reverseNumbers / (10000 * 100)).toFixed(2))
                        self.reverseNumbersMillionFlag = true
                        self.reverseNumbersHundredMillionFlag = false
                        // 保留两位小数
                        self.reverseNumbersDecimals = 2
                    } else if (self.reverseNumbers / (10000 * 100 * 100) > 1) {
                        self.reverseNumbers = Number((self.reverseNumbers / (10000 * 100 * 100)).toFixed(2))
                        self.reverseNumbersMillionFlag = false
                        self.reverseNumbersHundredMillionFlag = true
                        // 保留两位小数
                        self.reverseNumbersDecimals = 2
                    } else if (self.reverseNumbers / 10000 < 1) {
                        self.reverseNumbersMillionFlag = false
                        self.reverseNumbersHundredMillionFlag = false
                        // 不保留小数
                        self.reverseNumbersDecimals = 0
                    }
                })
            },

            // 今日异常数量
            getTodayReverseExceptionNumber() {
                let self = this
                selectTodayReverseExceptionNumber().then(data => {
                    self.past_today_reverse_exception_number = self.todayReverseExceptionNumber
                    self.todayReverseExceptionNumber = data.result
                    if (self.todayReverseExceptionNumber / (10000 * 100) > 1) {
                        self.todayReverseExceptionNumber = Number((self.todayReverseExceptionNumber / (10000 * 100)).toFixed(2))
                        self.todayReverseExceptionNumberMillionFlag = true
                        self.todayReverseExceptionNumberHundredMillionFlag = false
                        // 保留两位小数
                        self.todayReverseExceptionNumberDecimals = 2
                    } else if (self.todayReverseExceptionNumber / (10000 * 100 * 100) > 1) {
                        self.todayReverseExceptionNumber = Number((self.todayReverseExceptionNumber / (10000 * 100 * 100)).toFixed(2))
                        self.todayReverseExceptionNumberMillionFlag = false
                        self.todayReverseExceptionNumberHundredMillionFlag = true
                        // 保留两位小数
                        self.todayReverseExceptionNumberDecimals = 2
                    } else if (self.todayReverseExceptionNumber / 10000 < 1) {
                        self.todayReverseExceptionNumberMillionFlag = false
                        self.todayReverseExceptionNumberHundredMillionFlag = false
                        // 不保留小数
                        self.todayReverseExceptionNumberDecimals = 0
                    }
                })
            },

            // 计算总处理事件
            getDealEventNumber() {
                let self = this
                selectDealEventNumber().then(data => {
                    self.past_deal_event_number = self.dealEventNumber
                    self.dealEventNumber = data.result
                    if (self.dealEventNumber / (10000 * 100) > 1) {
                        self.dealEventNumber = Number((self.dealEventNumber / (10000 * 100)).toFixed(2))
                        self.dealEventNumberMillionFlag = true
                        self.dealEventNumberHundredMillionFlag = false
                        // 保留两位小数
                        self.dealEventNumberDecimals = 2
                    } else if (self.dealEventNumber / (10000 * 100 * 100) > 1) {
                        self.dealEventNumber = Number((self.dealEventNumber / (10000 * 100 * 100)).toFixed(2))
                        self.dealEventNumberMillionFlag = false
                        self.dealEventNumberHundredMillionFlag = true
                        // 保留两位小数
                        self.dealEventNumberDecimals = 2
                    } else if (self.dealEventNumber / 10000 < 1) {
                        self.dealEventNumberMillionFlag = false
                        self.dealEventNumberHundredMillionFlag = false
                        // 不保留小数
                        self.dealEventNumberDecimals = 0
                    }
                })
            },

            // 异常一览
            getAllException() {
                let self = this
                self.exceptionList = []
                selectAllException().then(data => {
                    self.exceptionList = data.result
                    self.exceptionList.forEach(item => {
                        item.exceptionTime = self.formatDate(item.exceptionTime)
                    })
                })
            },

        }
    }
</script>

<style scoped>
    .container {
        /*width: 750px;*/
        /*height: 3371px;*/
        background: #00013B;
        position: relative;
    }

    .current_date {
        /*position: absolute;*/
        /*right: 230px;*/
        /*top: 80px;*/
        /*width: 63px;*/
        /*height: 22px;*/
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5297FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .current_year {
        /*position: absolute;*/
        margin-left: 10px;
        /*right: 110px;*/
        /*top: 100px;*/
        /*color: white;*/
        /*width: 151px;*/
        /*height: 22px;*/
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5297FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .current_week {
        /*position: absolute;*/
        margin-left: 10px;
        /*right: 40px;*/
        /*top: 100px;*/
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5297FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .echarts_map {
        /*width: 749px;*/
        /*height: 500px;*/
        background: #00023C;
        background-image: url("../../../static/images/app_shade.png"), url("../../../static/images/app_baseplate.gif"), url("../../../static/images/app_brighten.png");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: 100%
    }

    .bi_title {
        /*width: 255px;*/
        height: 23px;
        font-size: 15pt;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 12px;
        margin: 0 auto;
        padding-top: 20pt;
        text-align: center;
    }

    .volume_statistics {
        width: 100%;
        /*height: 35px;*/
        font-size: 17px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2AA8D3;
        /*line-height: 91px;*/
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0 auto;
        text-align: center;
    }

    .arrange_area {
        width: 20%;
        height: 36.6pt;
        background-image: url('../../../static/images/app_data_bg.png');
        background-size: cover;
    }

    .arrange_area_number {
        /*width: 44px;*/
        height: 20px;
        font-size: 13.53pt;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #08C8F1;
        margin: 5px auto 0;
        text-align: center;
    }

    .arrange_area_text {
        text-align: center;
        height: 16px;
        font-size: 8pt;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #08C8F2;
        margin: 5px auto 0;
        text-align: center;
    }

    .device_roam {
        width: 25%;
        height: 36.6pt;
        background-image: url('../../../static/images/app_data_bg.png');
        background-size: cover;
    }

    .device_roam_number {
        /*width: 74px;*/
        height: 20px;
        font-size: 13.53pt;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFB027;
        margin: 5px auto 0;
        text-align: center;
    }

    .number_style {
        height: 20px;
        font-size: 11.53pt;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFB027;
    }

    .device_roam_text {
        text-align: center;
        height: 16px;
        font-size: 8pt;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #FFB027;
        margin: 5px auto 0;
    }

    .today_exception {
        width: 20%;
        height: 36.6pt;
        background-image: url('../../../static/images/app_data_bg.png');
        background-size: cover;
    }

    .today_exception_number {
        /*width: 89px;*/
        height: 20px;
        font-size: 13.53pt;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FF3300;
        margin: 5px auto 0;
        text-align: center;
    }

    .today_exception_text {
        text-align: center;
        height: 16px;
        font-size: 8pt;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #FF3300;
        margin: 5px auto 0;
    }

    .deal_event {
        width: 20%;
        height: 36.6pt;
        background-image: url('../../../static/images/app_data_bg.png');
        background-size: cover;
    }

    .deal_event_number {
        /*width: 60px;*/
        height: 20px;
        font-size: 13.53pt;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #00CC00;
        margin: 5px auto 0;
        text-align: center;
    }

    .deal_event_text {
        text-align: center;
        height: 16px;
        font-size: 8pt;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #00CC00;
        margin: 5px auto 0;
    }

    .bi_product {
        width: 95%;
        height: 28.25pt;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 10px;
        margin-top: 10px;
    }

    .bi_product_add {
        width: 132px;
        height: 28.25pt;
        font-size: 12pt;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 28.25pt;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_device {
        width: 95%;
        height: 28.25pt;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 10px;
        margin-top: 10px;
    }

    .bi_insert_device {
        width: 132px;
        height: 28.25pt;
        font-size: 12pt;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 28.25pt;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_data {
        width: 95%;
        height: 28.25pt;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 10px;
        margin-top: 10px;
    }

    .bi_data_type {
        width: 132px;
        height: 28.25pt;
        font-size: 12pt;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 28.25pt;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_court {
        width: 95%;
        height: 28.25pt;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 10px;
        margin-top: 10px;
    }

    .bi_insert_court {
        width: 132px;
        height: 28.25pt;
        font-size: 12pt;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 28.25pt;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_product_type {
        width: 95%;
        height: 28.25pt;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 10px;
        margin-top: 10px;
    }

    .bi_product_type_distribute {
        width: 132px;
        height: 28.25pt;
        font-size: 12pt;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 28.25pt;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_exception {
        width: 95%;
        height: 57px;
        background: linear-gradient(92deg, #0826B7, #01B5FF);
        opacity: 0.7;
        margin-left: 10px;
    }

    .bi_exception_show {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2AA8D3;
        line-height: 54px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .exception_title {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FEE614;
        flex: 1;
    }

    .exception_content {
        font-size: 8px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 25px;
        flex: 1;
    }

    .reSet {
        width: 38px;
        height: 38px;
        position: absolute;
        top: 150px;
        left: 20px;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// src/view/biApp/index.vue